import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param tenantId
 * @param dnId
 * @param poId
 */
class DNServices {
    /**
     *
     * @param {*} payload
     * @return
     */
    createDN = async (payload) => {
      const cn = await Helpers.post({
        url: Constants.DN,
        data: payload,
      });
      return cn;
    }

    /**
     *
     * @param {*} payload
     * @return
     */
     updateDN = async (payload) => {
       const cn = await Helpers.put({
         url: Constants.DN,
         data: payload,
       });
       return cn;
     }

     /**
      *
      * @param {*} payload
      * @return
      */
     updateDNStatus = async (payload) => {
       const po = await Helpers.put({
         url: Constants.DN_STATUS,
         data: payload,
       });
       return po;
     }

     /**
      *
      * @param {*} payload
      * @return
      */
        updateDNWorkflowStep = async (payload) => {
          const cn = await Helpers.post({
            url: Constants.DN_WORKFLOW,
            data: payload,
          });
          return cn;
        }

        /**
         *
         * @param {*} payload
         * @return
         */
      deleteDN = async (payload) => {
        const cn = await Helpers.delete({
          url: Constants.DN,
          data: payload,
        });
        return cn;
      }

      /**
       * @param {*} orgId
       * @param {*} entityType
       * @param {*} dnId
       * @param {*} page
       * @param tenantId
       * @param customerId
       * @param tenantSellerId
       * @param status
       * @param searchKeyword
       * @param {*} limit
       * @return
       */
    getDN = async (tenantId, tenantSellerId, dnId, status, page, limit, searchKeyword, is_list) => {
      let url = `${Constants.DN}?`;
      if (tenantId) url += `tenant_id=${tenantId}&`;
      if (tenantSellerId) url += `tenant_seller_id=${tenantSellerId}&`;
      if (dnId) url += `dn_id=${dnId}&`;
      if (status) url += `status=${status}&`;
      if (limit) url += `limit=${limit}&`;
      if (page) url += `page=${page}&`;
      if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
      if (is_list) url += `is_list=true&`;

      const cn = await Helpers.get({ url });
      return cn;
    }
}
export default new DNServices();
